import { Component } from '@theme/component';

class HeroCarousel extends Component {
  #swiper = null;

  get loop() {
    return this.querySelectorAll('.swiper-slide').length > 2;
  }

  connectedCallback() {
    super.connectedCallback();
    
    const el = this.querySelector('[ref=swiper]');

    if (!el) {
      return;
    }

    this.#swiper = new window.Swiper(el, {
      loop: true,
      allowTouchMove: true,
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 0,
      observer: false,
      resizeObserver: false,
      autoHeight: false,
      watchOverflow: false,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });
  }

  slideNext(){
    this.#swiper.slideNext();
  }

  slidePrev() {
    this.#swiper.slidePrev();
  }
}

if (!customElements.get('hero-carousel')) {
  customElements.define('hero-carousel', HeroCarousel);
}